import React from "react";
import { Reveal, Overline } from "./Reveal";
import { MANIFESTO } from "../lib/data";

export const Manifesto = () => (
  <section data-testid="manifesto" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36">
    <Reveal className="max-w-3xl mb-20">
      <Overline>The Manifesto</Overline>
      <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
        Four convictions that govern every trade we make.
      </h2>
    </Reveal>

    <div className="divide-y divide-line border-t border-line">
      {MANIFESTO.map((m, i) => (
        <Reveal key={m.n} delay={i * 0.05}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 group">
            <div className="md:col-span-3">
              <span className="font-serif italic text-6xl sm:text-7xl font-light text-line group-hover:text-brass transition-colors duration-500">
                {m.n}
              </span>
            </div>
            <h3 className="md:col-span-4 font-serif text-2xl sm:text-3xl font-medium tracking-tight text-bone">
              {m.title}
            </h3>
            <p className="md:col-span-5 text-mute leading-relaxed">{m.body}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
